import { React, useState } from "react";
import { Image } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import xclose from '../../assets/icons/x-close.svg';
import { toLower } from "lodash";

const ConfirmAlertModal = (props) => {
  console.log("props of confirmation box",props);
  
  let formName = props.formName;
  const closeTab = () => {
    window.close();
  };

  return (
      <Modal
        className="confirmAlertModal"
        show={props.show}
        onHide={props.handleClose}
        animation={false}
        backdrop="static"
      >
        <br></br>
        <Modal.Header className="confirm-modal" >
              <div>
                <Modal.Title className="confirmation-header">{props.action==="Add" ? "Add new ":"Edit "}{toLower(formName)}</Modal.Title>
                </div>
                <Image className="cross-btn-confirm confirm" src={xclose} onClick={() => props.handleClose()}></Image>
            </Modal.Header>
        <Modal.Body className="confirmcss">
         <div className="confirmation-body"> Are you sure you want to {toLower(props.action)} this {toLower(formName)}  ?</div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start confirmation-footer" >
          <Button variant="primary" onClick={() => props.handleYes()} className="modal-btn-sub" >
            Yes
          </Button>
          <Button variant="outline-primary" onClick={() => props.handleClose()} className="modal-btn-sub" >
            No
          </Button>
        </Modal.Footer>
      </Modal>
  );
};

export default ConfirmAlertModal;
